export const csv_category = {
    alcoholic_beverages: {
      cat1: 'Groceries',
      cat2: 'Groceries',
      cat3: 'Food & Dining > Groceries',
      cat4: 'Groceries',
      cat5: 'Groceries',
      cat6: 'Groceries',
      cat7: 'Groceries',
      cat8: 'Food > Groceries',
      cat9: 'Groceries',
      cat10: 'Food > Groceries',
      cat11: 'Household > Groceries',
      cat12: 'Groceries',
      cat13: 'Groceries',
      cat14: 'Groceries',
    },
    food_home: {
      cat1: 'Groceries',
      cat2: 'Groceries',
      cat3: 'Food & Dining > Groceries',
      cat4: 'Groceries',
      cat5: 'Groceries',
      cat6: 'Groceries',
      cat7: 'Groceries',
      cat8: 'Food > Groceries',
      cat9: 'Groceries',
      cat10: 'Food > Groceries',
      cat11: 'Household > Groceries',
      cat12: 'Groceries',
      cat13: 'Groceries',
      cat14: 'Groceries',
    },
    mortgage_and_rent: {
      cat1: 'Rent or Mortgage',
      cat2: 'Rent/Mortgage',
      cat3: 'Home > Mortgage & Rent',
      cat4: 'Housing: Rent/Mortgage',
      cat5: 'Mortgage/Rent',
      cat6: 'Housing > Rent/Mortgage',
      cat7: 'Rent/Mortgage',
      cat8: 'Housing > Rent/Mortgage',
      cat9: 'Rent/Mortgage',
      cat10: 'Housing > Mortgage/Rent',
      cat11: 'Household > Rent/Mortgage',
      cat12: 'Rent/Mortgage',
      cat13: 'Rent/Mortgage',
      cat14: 'Rent/Mortgage',
    },
    food_out: {
      cat1: 'Dining Out',
      cat2: 'Dining Out',
      cat3: 'Food & Dining > Restaurants',
      cat4: 'Dining',
      cat5: 'Dining Out',
      cat6: 'Dining Out',
      cat7: 'Dining Out',
      cat8: 'Food > Dining Out',
      cat9: 'Dining Out',
      cat10: 'Food > Restaurants',
      cat11: 'Household > Dining',
      cat12: 'Dining Out',
      cat13: 'Dining Out',
      cat14: 'Dining Out',
    },
    rent_or_mortgage: {
      cat1: 'Rent or Mortgage Payments',
      cat2: 'Rent/Mortgage',
      cat3: 'Home > Mortgage & Rent',
      cat4: 'Housing: Rent/Mortgage',
      cat5: 'Mortgage/Rent',
      cat6: 'Housing > Rent/Mortgage',
      cat7: 'Rent/Mortgage',
      cat8: 'Housing > Rent/Mortgage',
      cat9: 'Rent/Mortgage',
      cat10: 'Housing > Rent/Mortgage',
      cat11: 'Household > Rent/Mortgage',
      cat12: 'Rent/Mortgage',
      cat13: 'Rent/Mortgage',
      cat14: 'Rent/Mortgage',
    },
    gasoline: {
      cat1: 'Gasoline & e-charging',
      cat2: 'Transportation: Fuel',
      cat3: 'Auto & Transport > Gas & Fuel',
      cat4: 'Auto: Gas & Charging',
      cat5: 'Gasoline',
      cat6: 'Transportation > Fuel',
      cat7: 'Gas & Fuel',
      cat8: 'Transportation > Gas & Fuel',
      cat9: 'Gasoline',
      cat10: 'Transportation > Gas',
      cat11: 'Household > Gas & Fuel',
      cat12: 'Gas & Fuel',
      cat13: 'Fuel',
      cat14: 'Gas & Charging',
    },
    clothing_items_and_services: {
      cat1: 'Clothing & Jewelry',
      cat2: 'Clothing',
      cat3: 'Shopping > Clothing & Accessories',
      cat4: 'Clothing & Accessories',
      cat5: 'Clothing',
      cat6: 'Clothing',
      cat7: 'Clothing',
      cat8: 'Shopping > Clothing',
      cat9: 'Clothing',
      cat10: 'Lifestyle > Clothing',
      cat11: 'Household > Clothing',
      cat12: 'Clothing',
      cat13: 'Clothing',
      cat14: 'Clothing',
    },
    vehicle_purchase_and_lease: {
      cat1: 'Car Payments',
      cat2: 'Transportation: Car Payment',
      cat3: 'Auto & Transport > Auto Payment',
      cat4: 'Auto Loan/Lease',
      cat5: 'Auto Loan',
      cat6: 'Transportation > Car Payment',
      cat7: 'Auto Payments',
      cat8: 'Transportation > Auto Payment',
      cat9: 'Car Payment',
      cat10: 'Transportation > Auto Payment',
      cat11: 'Household > Car Payment',
      cat12: 'Car Payment',
      cat13: 'Auto Payment',
      cat14: 'Auto Payment',
    },
    health_insurance: {
      cat1: 'Health Insurance',
      cat2: 'Health Insurance',
      cat3: 'Insurance > Health Insurance',
      cat4: 'Insurance: Health',
      cat5: 'Health Insurance',
      cat6: 'Insurance > Health',
      cat7: 'Health Insurance',
      cat8: 'Insurance > Health Insurance',
      cat9: 'Health Insurance',
      cat10: 'Insurance > Health',
      cat11: 'Household > Health Insurance',
      cat12: 'Health Insurance',
      cat13: 'Health Insurance',
      cat14: 'Health Insurance',
    },
    other_debt_payments: {  
      cat1: 'Other Debt Payments',
      cat2: 'Debt Payments',
      cat3: 'Transfers > Debt',
      cat4: 'Debt Payments',
      cat5: 'Debt Payments',
      cat6: 'Debt',
      cat7: 'Debt Payments',
      cat8: 'Debt Payments',
      cat9: 'Debt Payments',
      cat10: 'Debt Payments',
      cat11: 'Household > Debt Payments',
      cat12: 'Debt Payments',
      cat13: 'Debt Payments',
      cat14: 'Debt Payments',
    },
    life_and_personal_insurance: {
      cat1: 'Life & Other Personal Insurance',
      cat2: 'Life Insurance',
      cat3: 'Insurance > Life Insurance',
      cat4: 'Insurance: Life & Personal',
      cat5: 'Life Insurance',
      cat6: 'Insurance > Life',
      cat7: 'Life Insurance',
      cat8: 'Insurance > Life Insurance',
      cat9: 'Life Insurance',
      cat10: 'Insurance > Life',
      cat11: 'Household > Life Insurance',
      cat12: 'Life Insurance',
      cat13: 'Life Insurance',
      cat14: 'Life Insurance',
    },
    cash_contributions: {
      cat1: 'Charitable Giving',
      cat2: 'Charity',
      cat3: 'Donations',
      cat4: 'Charitable Giving',
      cat5: 'Charitable Donations',
      cat6: 'Charity',
      cat7: 'Charitable Giving',
      cat8: 'Giving > Charitable Donations',
      cat9: 'Charitable Giving',
      cat10: 'Giving',
      cat11: 'Household > Charitable Donations',
      cat12: 'Charitable Giving',
      cat13: 'Charitable Giving',
      cat14: 'Charitable Giving',
    },
    savings: {
      cat1: 'To Savings Monthly',
      cat2: 'Savings Goals',
      cat3: 'Transfers > Savings',
      cat4: 'Savings',
      cat5: 'Savings',
      cat6: 'Savings',
      cat7: 'Savings',
      cat8: 'Savings',
      cat9: 'Savings',
      cat10: 'Savings',
      cat11: 'Household > Savings',
      cat12: 'Savings',
      cat13: 'Savings',
      cat14: 'Savings',
    },
    medical_services: {
      cat1: 'Medical Spending',
      cat2: 'Medical',
      cat3: 'Health & Wellness > Medical/Dental',
      cat4: 'Health & Wellness',
      cat5: 'Medical Expenses',
      cat6: 'Health',
      cat7: 'Medical',
      cat8: 'Health > Medical Expenses',
      cat9: 'Medical Expenses',
      cat10: 'Health > Medical Expenses',
      cat11: 'Household > Medical Expenses',
      cat12: 'Medical Expenses',
      cat13: 'Medical Expenses',
      cat14: 'Medical Expenses',
    },
    pets: {
      cat1: 'Pets',
      cat2: 'Pets',
      cat3: 'Pets',
      cat4: 'Pets',
      cat5: 'Pet Expenses',
      cat6: 'Pets',
      cat7: 'Pets',
      cat8: 'Lifestyle > Pets',
      cat9: 'Pets',
      cat10: 'Lifestyle > Pets',
      cat11: 'Household > Pets',
      cat12: 'Pets',
      cat13: 'Pets',
      cat14: 'Pets',
    },
    public_and_other_transportation: {
      cat1: 'Transportation Fares',
      cat2: 'Transportation: Other',
      cat3: 'Auto & Transport > Public Transport',
      cat4: 'Transportation',
      cat5: 'Public Transportation',
      cat6: 'Transportation > Public Transport',
      cat7: 'Public Transportation',
      cat8: 'Transportation > Public Transport',
      cat9: 'Public Transportation',
      cat10: 'Transportation > Public Transport',
      cat11: 'Household > Public Transport',
      cat12: 'Public Transportation',
      cat13: 'Public Transportation',
      cat14: 'Public Transportation',
    },
    vehicle_insurance: {
      cat1: 'Car Insurance',
      cat2: 'Transportation: Auto Insurance',
      cat3: 'Auto & Transport > Insurance',
      cat4: 'Auto: Insurance',
      cat5: 'Auto Insurance',
      cat6: 'Transportation > Insurance',
      cat7: 'Auto Insurance',
      cat8: 'Insurance > Auto Insurance',
      cat9: 'Auto Insurance',
      cat10: 'Insurance > Auto',
      cat11: 'Household > Auto Insurance',
      cat12: 'Auto Insurance',
      cat13: 'Auto Insurance',
      cat14: 'Auto Insurance',
    },
    vehicle_maintenance_and_repairs: {
      cat1: 'Car Maintenance',
      cat2: 'Transportation: Maintenance',
      cat3: 'Auto & Transport > Auto Repair',
      cat4: 'Auto: Maintenance',
      cat5: 'Auto Maintenance',
      cat6: 'Transportation > Maintenance',
      cat7: 'Auto Maintenance',
      cat8: 'Transportation > Maintenance',
      cat9: 'Car Maintenance',
      cat10: 'Transportation > Maintenance/Repairs',
      cat11: 'Household > Car Maintenance',
      cat12: 'Auto Maintenance',
      cat13: 'Car Maintenance',
      cat14: 'Auto Maintenance',
    },
    home_appliances_furniture_equipment: {
      cat1: 'Home Appliances & Furniture',
      cat2: 'Household Items',
      cat3: 'Home > Furniture/Appliances',
      cat4: 'Home Furnishings',
      cat5: 'Home Appliances',
      cat6: 'Housing > Furniture/Equipment',
      cat7: 'Household Supplies',
      cat8: 'Home > Furniture/Equipment',
      cat9: 'Furniture & Equipment',
      cat10: 'Housing > Furnishings/Appliances',
      cat11: 'Household > Furniture',
      cat12: 'Furniture & Equipment',
      cat13: 'Furniture & Equipment',
      cat14: 'Home Appliances',
    },
    cable_internet_streaming: {
      cat1: 'Cable / Internet / Streaming Services',
      cat2: 'Internet',
      cat3: 'Bills & Utilities > Cable/Internet',
      cat4: 'Utilities: Cable/Internet',
      cat5: 'Cable/Internet',
      cat6: 'Utilities',
      cat7: 'Cable/Internet',
      cat8: 'Utilities > Cable/Internet',
      cat9: 'Cable/Internet',
      cat10: 'Utilities > Cable/Internet',
      cat11: 'Household > Cable/Internet',
      cat12: 'Cable/Internet',
      cat13: 'Cable/Internet',
      cat14: 'Cable/Internet',
    },
    personal_care_products_services: {
      cat1: 'Personal Care Products and Services',
      cat2: 'Personal Care',
      cat3: 'Shopping > Personal Care',
      cat4: 'Personal Care',
      cat5: 'Personal Care',
      cat6: 'Personal Care',
      cat7: 'Personal Care',
      cat8: 'Lifestyle > Personal Care',
      cat9: 'Personal Care',
      cat10: 'Lifestyle > Personal Care',
      cat11: 'Household > Personal Care',
      cat12: 'Personal Care',
      cat13: 'Personal Care',
      cat14: 'Personal Care',
    },
    miscellaneous: {
      cat1: 'Miscellaneous',
      cat2: 'Miscellaneous',
      cat3: 'Other',
      cat4: 'Miscellaneous',
      cat5: 'Miscellaneous',
      cat6: 'Miscellaneous',
      cat7: 'Miscellaneous',
      cat8: 'Miscellaneous',
      cat9: 'Miscellaneous',
      cat10: 'Miscellaneous',
      cat11: 'Miscellaneous',
      cat12: 'Miscellaneous',
      cat13: 'Miscellaneous',
      cat14: 'Miscellaneous',
    },
    fun_leisure: {
      cat1: 'Fun & Leisure',
      cat2: 'Entertainment',
      cat3: 'Entertainment',
      cat4: 'Entertainment',
      cat5: 'Entertainment',
      cat6: 'Recreation',
      cat7: 'Entertainment',
      cat8: 'Entertainment',
      cat9: 'Entertainment',
      cat10: 'Lifestyle > Entertainment',
      cat11: 'Leisure & Entertainment',
      cat12: 'Entertainment',
      cat13: 'Entertainment',
      cat14: 'Entertainment',
    },
    utilities_other: {
      cat1: 'Utilities - Other',
      cat2: 'Utilities: Other',
      cat3: 'Home > Utilities',
      cat4: 'Utilities',
      cat5: 'Utilities',
      cat6: 'Utilities',
      cat7: 'Utilities',
      cat8: 'Utilities',
      cat9: 'Utilities',
      cat10: 'Housing > Utilities',
      cat11: 'Household > Utilities',
      cat12: 'Utilities',
      cat13: 'Utilities',
      cat14: 'Utilities',
    },
    to_savings_monthly: {
      cat1: 'To Savings Monthly',
      cat2: 'Savings Goals',
      cat3: 'Transfers > Savings',
      cat4: 'Savings',
      cat5: 'Savings',
      cat6: 'Savings',
      cat7: 'Savings',
      cat8: 'Savings',
      cat9: 'Savings',
      cat10: 'Savings',
      cat11: 'Household > Savings',
      cat12: 'Savings',
      cat13: 'Savings',
      cat14: 'Savings',
    },
    tobacco_and_smoking: {
      cat1: '',
      cat2: '',
      cat3: '',
      cat4: '',
      cat5: '',
      cat6: '',
      cat7: '',
      cat8: '',
      cat9: '',
      cat10: '',
      cat11: '',
      cat12: '',
      cat13: '',
      cat14: '',
    },
    education: {
      cat1: 'Education & Childcare',
      cat2: 'Education',
      cat3: 'Education',
      cat4: 'Education & Childcare',
      cat5: 'Education',
      cat6: 'Education',
      cat7: 'Education & Childcare',
      cat8: 'Education & Childcare',
      cat9: 'Education & Childcare',
      cat10: 'Education & Childcare',
      cat11: 'Household > Education',
      cat12: 'Education & Childcare',
      cat13: 'Education & Childcare',
      cat14: 'Education & Childcare',
    },
    reading: {
      // same data from education
      cat1: 'Education & Childcare',
      cat2: 'Education',
      cat3: 'Education',
      cat4: 'Education & Childcare',
      cat5: 'Education',
      cat6: 'Education',
      cat7: 'Education & Childcare',
      cat8: 'Education & Childcare',
      cat9: 'Education & Childcare',
      cat10: 'Education & Childcare',
      cat11: 'Household > Education',
      cat12: 'Education & Childcare',
      cat13: 'Education & Childcare',
      cat14: 'Education & Childcare',
    },
    toys_and_hobbies: {
      // data from fun and leisure
      cat1: 'Fun & Leisure',
      cat2: 'Entertainment',
      cat3: 'Entertainment',
      cat4: 'Entertainment',
      cat5: 'Entertainment',
      cat6: 'Recreation',
      cat7: 'Entertainment',
      cat8: 'Entertainment',
      cat9: 'Entertainment',
      cat10: 'Lifestyle > Entertainment',
      cat11: 'Leisure & Entertainment',
      cat12: 'Entertainment',
      cat13: 'Entertainment',
      cat14: 'Entertainment',
    },  
    media_hardware_and_services: {
      cat1: 'Cable / Internet / Streaming Services',
      cat2: 'Internet',
      cat3: 'Bills & Utilities > Cable/Internet',
      cat4: 'Utilities: Cable/Internet',
      cat5: 'Cable/Internet',
      cat6: 'Utilities',
      cat7: 'Cable/Internet',
      cat8: 'Utilities > Cable/Internet',
      cat9: 'Cable/Internet',
      cat10: 'Utilities > Cable/Internet',
      cat11: 'Household > Cable/Internet',
      cat12: 'Cable/Internet',
      cat13: 'Cable/Internet',
      cat14: 'Cable/Internet',
    },
    fees_and_admissions : {
      cat1: '',
      cat2: '',
      cat3: '',
      cat4: '',
      cat5: '',
      cat6: '',
      cat7: '',
      cat8: '',
      cat9: '',
      cat10: '',
      cat11: '',
      cat12: '',
      cat13: '',
      cat14: '',
    },
    medical_supplies : {
      // data from medical spending
      cat1: 'Medical Spending',
      cat2: 'Medical',
      cat3: 'Health & Wellness > Medical/Dental',
      cat4: 'Health & Wellness',
      cat5: 'Medical Expenses',
      cat6: 'Health',
      cat7: 'Medical',
      cat8: 'Health > Medical Expenses',
      cat9: 'Medical Expenses',
      cat10: 'Health > Medical Expenses',
      cat11: 'Household > Medical Expenses',
      cat12: 'Medical Expenses',
      cat13: 'Medical Expenses',
      cat14: 'Medical Expenses',
    },
    prescription_drugs : {
      // data from medical spending
      cat1: 'Medical Spending',
      cat2: 'Medical',
      cat3: 'Health & Wellness > Medical/Dental',
      cat4: 'Health & Wellness',
      cat5: 'Medical Expenses',
      cat6: 'Health',
      cat7: 'Medical',
      cat8: 'Health > Medical Expenses',
      cat9: 'Medical Expenses',
      cat10: 'Health > Medical Expenses',
      cat11: 'Household > Medical Expenses',
      cat12: 'Medical Expenses',
      cat13: 'Medical Expenses',
      cat14: 'Medical Expenses',
    },
    furniture_and_appliances : {
      cat1: 'Home Appliances / Furniture / Equipment',
      cat2: 'Household Items',
      cat3: 'Home > Furniture/Appliances',
      cat4: 'Housing: Furniture & Equipment',
      cat5: 'Home Furnishings',
      cat6: 'Housing > Furniture/Equipment',
      cat7: 'Household Supplies',
      cat8: 'Home > Furniture & Equipment',
      cat9: 'Furniture & Equipment',
      cat10: 'Housing > Furnishings/Appliances',
      cat11: 'Household > Furniture',
      cat12: 'Furniture & Equipment',
      cat13: 'Furniture & Equipment',
      cat14: 'Furniture & Equipment',
    },
    housekeeping_supplies : {
      // data from Home Maintenance & Services
      cat1: 'Home Maintenance & Services',
      cat2: 'Home Maintenance',
      cat3: 'Home > Maintenance',
      cat4: 'Housing: Maintenance & Services',
      cat5: 'Home Maintenance',
      cat6: 'Housing > Maintenance',
      cat7: 'Home Maintenance',
      cat8: 'Housing > Maintenance',
      cat9: 'Home Maintenance',
      cat10: 'Housing > Maintenance/Repairs',
      cat11: 'Household > Maintenance',
      cat12: 'Home Maintenance',
      cat13: 'Home Maintenance',
      cat14: 'Home Maintenance',
    },
    other_household_expenses : {
      // data from Home Utilites-Other
      cat1: 'Utilities - Other',
      cat2: 'Utilities: Other',
      cat3: 'Home > Utilities',
      cat4: 'Utilities',
      cat5: 'Utilities',
      cat6: 'Utilities',
      cat7: 'Utilities',
      cat8: 'Utilities',
      cat9: 'Utilities',
      cat10: 'Housing > Utilities',
      cat11: 'Household > Utilities',
      cat12: 'Utilities',
      cat13: 'Utilities',
      cat14: 'Utilities',
    },
    water_and_public_services : {
      // data from Home Utilites-Other
      cat1: 'Utilities - Other',
      cat2: 'Utilities: Other',
      cat3: 'Home > Utilities',
      cat4: 'Utilities',
      cat5: 'Utilities',
      cat6: 'Utilities',
      cat7: 'Utilities',
      cat8: 'Utilities',
      cat9: 'Utilities',
      cat10: 'Housing > Utilities',
      cat11: 'Household > Utilities',
      cat12: 'Utilities',
      cat13: 'Utilities',
      cat14: 'Utilities',
    },
    telephone_services : {
      cat1: 'Phone Services',
      cat2: 'Phone',
      cat3: 'Bills & Utilities > Phone',
      cat4: 'Utilities: Phone Services',
      cat5: 'Phone Bill',
      cat6: 'Utilities',
      cat7: 'Phone Services',
      cat8: 'Utilities > Phone',
      cat9: 'Phone Services',
      cat10: 'Utilities > Phone',
      cat11: 'Household > Phone',
      cat12: 'Phone Services',
      cat13: 'Phone Services',
      cat14: 'Phone Services',
    },
    personal_services : {
      cat1: 'Education & Childcare',
      cat2: 'Education',
      cat3: 'Education',
      cat4: 'Education & Childcare',
      cat5: 'Education',
      cat6: 'Education',
      cat7: 'Education & Childcare',
      cat8: 'Education & Childcare',
      cat9: 'Education & Childcare',
      cat10: 'Education & Childcare',
      cat11: 'Household > Education',
      cat12: 'Education & Childcare',
      cat13: 'Education & Childcare',
      cat14: 'Education & Childcare',
    },
    heating_fuels_other : {
      cat1: 'Utilities - Other',
      cat2: 'Utilities: Other',
      cat3: 'Home > Utilities',
      cat4: 'Utilities',
      cat5: 'Utilities',
      cat6: 'Utilities',
      cat7: 'Utilities',
      cat8: 'Utilities',
      cat9: 'Utilities',
      cat10: 'Housing > Utilities',
      cat11: 'Household > Utilities',
      cat12: 'Utilities',
      cat13: 'Utilities',
      cat14: 'Utilities',
    },
    electricity : {
      cat1: 'Utilities - Power Bill',
      cat2: 'Utilities: Electric',
      cat3: 'Home > Utilities > Electricity',
      cat4: 'Utilities: Electric',
      cat5: 'Electric Bill',
      cat6: 'Utilities',
      cat7: 'Utilities',
      cat8: 'Utilities',
      cat9: 'Electric Bill',
      cat10: 'Housing > Utilities',
      cat11: 'Household > Power Bill',
      cat12: 'Utilities',
      cat13: 'Utilities',
      cat14: 'Utilities',
    },
    natural_gas : {
      cat1: 'Utilities - Other',
      cat2: 'Utilities: Other',
      cat3: 'Home > Utilities',
      cat4: 'Utilities',
      cat5: 'Utilities',
      cat6: 'Utilities',
      cat7: 'Utilities',
      cat8: 'Utilities',
      cat9: 'Utilities',
      cat10: 'Housing > Utilities',
      cat11: 'Household > Utilities',
      cat12: 'Utilities',
      cat13: 'Utilities',
      cat14: 'Utilities',
    },
    other_lodging : {
      cat1: 'Fun & Leisure',
      cat2: 'Entertainment',
      cat3: 'Entertainment',
      cat4: 'Entertainment',
      cat5: 'Entertainment',
      cat6: 'Recreation',
      cat7: 'Entertainment',
      cat8: 'Entertainment',
      cat9: 'Entertainment',
      cat10: 'Lifestyle > Entertainment',
      cat11: 'Leisure & Entertainment',
      cat12: 'Entertainment',
      cat13: 'Entertainment',
      cat14: 'Entertainment',
    },
    home_maintenance_and_repairs : {
      cat1: 'Home Maintenance & Services',
      cat2: 'Home Maintenance',
      cat3: 'Home > Maintenance',
      cat4: 'Housing: Maintenance & Services',
      cat5: 'Home Maintenance',
      cat6: 'Housing > Maintenance',
      cat7: 'Home Maintenance',
      cat8: 'Housing > Maintenance',
      cat9: 'Home Maintenance',
      cat10: 'Housing > Maintenance/Repairs',
      cat11: 'Household > Maintenance',
      cat12: 'Home Maintenance',
      cat13: 'Home Maintenance',
      cat14: 'Home Maintenance',
    },

  };
  